import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FeatureFlagService } from '../services/feature-flag.service';

/**
 * Muestra su contenido solo si la feature flag indicada está habilitada para el usuario.
 *
 * Uso:  <div *featureEnabled="'POS'"> ... </div>
 *
 * Reacciona a flags$, así que si las flags llegan después del render (login recién hecho), el
 * contenido aparece/desaparece sin necesidad de refrescar.
 */
@Directive({ selector: '[featureEnabled]' })
export class FeatureEnabledDirective implements OnInit, OnDestroy {
  private key = '';
  private hasView = false;
  private sub?: Subscription;

  @Input() set featureEnabled(key: string) {
    this.key = key;
    this.render();
  }

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.sub = this.featureFlagService.flags$.subscribe(() => this.render());
  }

  private render(): void {
    const enabled = this.featureFlagService.isEnabled(this.key);
    if (enabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!enabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
